<template lang="pug">
.print-labels
  .print-layout1.left(:style="`width:${dataForm.containerWidth}`")
    .line(v-for="index in quantity" :class="{'page-break': index % 3 === 0}")
      .label-tier(:style="`width: ${dataForm.width}; height: ${dataForm.height}`")
        div(v-if="type === 'static'") -t{{ index }}
        .code-tier(v-if="type === 'code'")
          QRCode(v-if="type === 'code'" :text="`-t${index}`" width="50px")
          div -t{{ index }}
      .space-tier(v-if="index % 3 !== 0" :style="`width: ${dataForm.spaceBetween}; height: ${dataForm.height}`")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import QRCode from '@/components/elements/QRCode'

export default {
  name: 'PrintLabels',

  mixins: [mForm, mFilters],

  components: { QRCode },

  data () {
    return {
      dataForm: {
        containerWidth: '106mm',
        height: '24mm',
        width: '32mm',
        spaceBetween: '5mm'
      },
      type: '',
      quantity: 0
    }
  },

  mounted () {
    this.setPageSize()
    this.type = this.$route.params.type
    this.quantity = this.$route.query.quantity * 1
  },

  methods: {
    setPageSize () {
      const style = document.createElement('style')
      style.innerHTML = `@page {size: ${this.dataForm.containerWidth} ${this.dataForm.height}}`
      document.head.appendChild(style)
    }
  }
}
</script>

<style lang="stylus">
.print-labels
  position relative

.print-layout1
  background-color black

.page-break
  break-inside avoid
  background-color yellow
  box-sizing border-box

.label-tier
  display inline-flex
  font-size 6mm
  box-sizing border-box
  vertical-align middle
  justify-content center
  align-items center
  background-color white
  font-weight 600

.space-tier
  background-color rgb(200, 200, 200)
  display inline-block
  vertical-align middle

.code-tier
  display flex
  align-items center

@media print
  .container, body
    padding 0
    margin 0
    background-color white

  .print-layout1
    background-color white

  .space-tier
    background-color white
</style>



// WEBPACK FOOTER //
// src/components/pages/print/PageToPrintEnum.vue